export default {
  years: "Anni",
  countries: "Paesi",
  leadership: "Leadership",
  quality: "Qualità",
  solutions: "Soluzioni",
  facilities: "Strutture",
  approvals: "Approvazioni",
  customers: "Clienti",
  operations: "Operazioni",
  focused: "Concentrato",
  vision: "Visione",
};

